var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('header',[_c('a',{attrs:{"href":"https://www.advamed.org/","target":"_blank"}},[_c('img',{staticClass:"logo",attrs:{"src":'./assets/' + _vm.logo,"alt":"AdvaMed"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }